import {
  WindowsSideRight,
  WindowsSideLeft,
} from '../../../../../../three/mesh/terraceCover/window/side'

export const WindowsSide = () => {
  return (
    <>
      <WindowsSideRight />
      <WindowsSideLeft />
    </>
  )
}
